{
  "familyId": "TAA-LEZEN-CONCLUSIE",
  "questions": [
    {
      "id": "TAA-LEZEN-CONCLUSIE-001",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "multiple_choice",
      "question": "Welke conclusie kun je trekken?",
      "options": ["Emma haalde een voldoende voor het leestoets.", "Emma is de beste lezer van de klas.", "Alle leerlingen lezen elke dag.", "Emma leest het liefst boeken."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "Alle leerlingen die elke dag lezen, haalden een voldoende voor het leestoets. Emma leest elke dag.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Conclusies trekken",
            "content": "Een conclusie volgt logisch uit de gegeven informatie. Combineer de feiten: (1) wie elke dag leest → voldoende, (2) Emma leest elke dag → dus Emma haalde een voldoende.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "conclusie_logisch",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "taa.conclusie-overgeneralisatie", "optionIndex": 1, "label": "Trekt te brede conclusie" },
          { "id": "taa.conclusie-niet-in-tekst", "optionIndex": 2, "label": "Conclusie staat niet in de tekst" },
          { "id": "taa.conclusie-detail-vs-conclusie", "optionIndex": 3, "label": "Verwart detail met conclusie" }
        ]
      },
      "feedback": {
        "explanationText": "Feit 1: Wie elke dag leest → voldoende. Feit 2: Emma leest elke dag. Conclusie: Emma haalde een voldoende. Dit volgt logisch uit de twee feiten.",
        "solutionSteps": [
          "Feit 1: Elke dag lezen → voldoende",
          "Feit 2: Emma leest elke dag",
          "Combineer: Emma → voldoende",
          "Conclusie: Emma haalde een voldoende"
        ],
        "distractorExplanations": {
          "0": "Goed! Dit volgt logisch uit de twee feiten.",
          "1": "Je dacht waarschijnlijk dat Emma de beste is. Maar de tekst zegt alleen dat ze een voldoende haalde, niet dat ze de beste is.",
          "2": "Je dacht waarschijnlijk dat alle leerlingen elke dag lezen. Maar de tekst zegt: 'alle leerlingen die elke dag lezen' — niet alle leerlingen doen dat.",
          "3": "Je dacht waarschijnlijk dat Emma boeken leest. Maar de tekst zegt niet wát Emma leest, alleen dát ze elke dag leest."
        }
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-002",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "multiple_choice",
      "question": "Welke conclusie kun je NIET trekken uit deze tekst?",
      "options": ["Het zal morgen ook regenen.", "De regen heeft invloed op de rivier.", "Er is veel water gevallen.", "De rivier kan overstromen."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "Het regent al drie dagen. De rivier staat hoger dan normaal.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Geldige vs ongeldige conclusies",
            "content": "Een geldige conclusie volgt uit de gegeven feiten. Een ongeldige conclusie voegt informatie toe die niet in de tekst staat. 'Het zal morgen ook regenen' staat niet in de tekst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "conclusie_ongeldig",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.conclusie-detail-vs-conclusie", "optionIndex": 1, "label": "Detail (invloed) i.p.v. conclusie" },
          { "id": "taa.conclusie-geldig-vs-ongeldig", "optionIndex": 2, "label": "Feit i.p.v. conclusie (regen)" },
          { "id": "taa.conclusie-voorspelling-vs-conclusie", "optionIndex": 3, "label": "Voorspelling i.p.v. conclusie" }
        ]
      },
      "feedback": {
        "explanationText": "De tekst zegt dat het drie dagen regent en de rivier hoog staat. Je kunt NIET concluderen dat het morgen ook regent — dat is een voorspelling, geen conclusie uit de feiten.",
        "solutionSteps": [
          "Check elke optie: volgt het uit de tekst?",
          "'Het zal morgen ook regenen' → NIET in de tekst",
          "Dit is een voorspelling, geen conclusie",
          "De andere opties volgen wél logisch uit de feiten"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Het zal morgen ook regenen' is een voorspelling die niet uit de tekst volgt.",
          "1": "Je dacht waarschijnlijk dat dit niet uit de tekst volgt. Maar het verband tussen regen en hoge rivier is logisch: regen → meer water → hogere rivier.",
          "2": "Je dacht waarschijnlijk dat dit niet uit de tekst volgt. Maar drie dagen regen = veel water. Dat is een logische conclusie.",
          "3": "Je dacht waarschijnlijk dat dit niet uit de tekst volgt. Maar een rivier die hoger staat dan normaal kan overstromen. Dat is een logische mogelijkheid."
        }
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-003",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "multiple_choice",
      "question": "Welke conclusie past?",
      "options": ["In Spanje groeien druiven goed.", "Spanje is het beste land voor druiven.", "Alle landen met zon verbouwen druiven.", "Druiven groeien alleen in Spanje."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "In landen met veel zon groeien druiven goed. Spanje heeft veel zon.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Conclusie = combinatie van feiten",
            "content": "Combineer de feiten: (1) veel zon → druiven groeien goed, (2) Spanje heeft veel zon. Conclusie: in Spanje groeien druiven goed.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "conclusie_combineren",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "taa.conclusie-correct", "optionIndex": 0, "label": "Correcte conclusie" },
          { "id": "taa.conclusie-overgeneralisatie", "optionIndex": 1, "label": "Trekt overgegeneraliseerde conclusie ('het beste')" },
          { "id": "taa.conclusie-exclusiviteit", "optionIndex": 3, "label": "Trekt exclusieve conclusie ('alleen')" }
        ]
      },
      "feedback": {
        "explanationText": "Feit 1: Veel zon → druiven groeien goed. Feit 2: Spanje heeft veel zon. Conclusie: In Spanje groeien druiven goed.",
        "solutionSteps": [
          "Feit 1: Veel zon → druiven groeien goed",
          "Feit 2: Spanje heeft veel zon",
          "Conclusie: In Spanje groeien druiven goed"
        ],
        "distractorExplanations": {
          "0": "Goed! Dit volgt logisch uit de twee feiten.",
          "1": "Je dacht waarschijnlijk dat Spanje het beste land is. Maar de tekst zegt niet dat Spanje het BESTE is — er kunnen meer landen met veel zon zijn.",
          "2": "Je dacht waarschijnlijk dat alle zonnige landen druiven verbouwen. Maar de tekst zegt dat druiven er goed GROEIEN, niet dat elk land ze ook daadwerkelijk verbouwt.",
          "3": "Je dacht waarschijnlijk dat druiven alleen in Spanje groeien. Maar de tekst zegt 'landen met veel zon' — er zijn meer landen met veel zon."
        }
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-004",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "multiple_choice",
      "question": "Wat is het verschil tussen een conclusie en een mening?",
      "options": ["Een conclusie volgt uit feiten, een mening is persoonlijk.", "Een conclusie is altijd waar, een mening niet.", "Een conclusie staat altijd in de tekst, een mening niet.", "Er is geen verschil."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Conclusie vs mening",
            "content": "Een conclusie volgt logisch uit gegeven feiten. Een mening is een persoonlijke opvatting. Conclusie: 'Het regent, dus de straat is nat.' Mening: 'Regen is vervelend.'",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "conclusie_vs_mening",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "taa.conclusie-altijd-waar", "optionIndex": 1, "label": "Denkt dat conclusies altijd waar zijn" },
          { "id": "taa.conclusie-mening-vs-conclusie", "optionIndex": 3, "label": "Verwart mening met conclusie (denkt geen verschil)" }
        ]
      },
      "feedback": {
        "explanationText": "Een conclusie volgt logisch uit feiten ('Het regent → de straat is nat'). Een mening is persoonlijk ('Regen is vervelend'). Het verschil: feiten vs gevoel.",
        "solutionSteps": [
          "Conclusie: volgt uit feiten (logisch verband)",
          "Mening: persoonlijke opvatting (gevoel/oordeel)",
          "Voorbeeld conclusie: 'Het regent, dus de straat is nat'",
          "Voorbeeld mening: 'Regen is vervelend'"
        ],
        "distractorExplanations": {
          "0": "Goed! Een conclusie is gebaseerd op feiten, een mening is persoonlijk.",
          "1": "Je dacht waarschijnlijk dat conclusies altijd waar zijn. Maar een conclusie kan ook fout zijn als de redenering niet klopt. Het verschil is dat een conclusie op feiten is gebaseerd.",
          "2": "Je dacht waarschijnlijk dat conclusies altijd in de tekst staan. Maar juist het punt is dat je een conclusie zelf trekt uit de feiten in de tekst.",
          "3": "Je dacht waarschijnlijk dat er geen verschil is. Maar er is een belangrijk verschil: feiten vs persoonlijke opvatting."
        }
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-005",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "fill_in",
      "question": "Wat zal er met de plant gebeuren? Typ je conclusie in één woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["doodgaan", "verwelken", "verdrogen", "sterven", "dood"],
        "caseSensitive": false,
        "placeholder": "De plant zal..."
      },
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "Planten hebben water nodig om te groeien. De plant in de klas krijgt al twee weken geen water.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Conclusie trekken",
            "content": "Combineer: (1) planten hebben water nodig, (2) deze plant krijgt geen water. Conclusie: de plant zal verwelken/doodgaan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "conclusie_invullen",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.conclusie-niet-in-tekst", "label": "Vult conclusie in die niet uit de feiten volgt" },
          { "id": "taa.conclusie-detail-vs-conclusie", "label": "Verwart een detail uit de tekst met de conclusie" }
        ]
      },
      "feedback": {
        "explanationText": "Planten hebben water nodig. Deze plant krijgt geen water. Conclusie: de plant zal verwelken of doodgaan.",
        "solutionSteps": [
          "Feit 1: Planten hebben water nodig",
          "Feit 2: De plant krijgt geen water",
          "Conclusie: De plant zal verwelken/doodgaan"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-006",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "text_highlight",
      "question": "Markeer de twee feiten waaruit je kunt concluderen dat Tim te laat op school komt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De school begint om half negen. Tim wordt om kwart over acht wakker. Hij heeft minstens een half uur nodig om zich klaar te maken en naar school te fietsen. Zijn moeder roept dat hij moet opschieten.",
        "correctHighlights": [
          { "start": 31, "end": 67, "text": "Tim wordt om kwart over acht wakker" },
          { "start": 68, "end": 155, "text": "Hij heeft minstens een half uur nodig om zich klaar te maken en naar school te fietsen" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Feiten voor een conclusie", "content": "Om een conclusie te trekken, combineer je feiten. Feit 1: Tim wordt om 8:15 wakker. Feit 2: Hij heeft minstens 30 minuten nodig. 8:15 + 30 min = 8:45. School begint om 8:30 → te laat!", "icon": "lightbulb" } }
      ],
      "conceptId": "conclusie_highlight_feiten",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.conclusie-detail-vs-conclusie", "label": "Markeert irrelevant detail in plaats van het feit dat de conclusie ondersteunt" },
          { "id": "taa.conclusie-niet-in-tekst", "label": "Mist een van de twee benodigde feiten" }
        ]
      },
      "feedback": {
        "explanationText": "Feit 1: Tim wordt om kwart over acht wakker. Feit 2: Hij heeft minstens een half uur nodig. Combineer: 8:15 + 30 min = 8:45. School begint om 8:30. Conclusie: Tim komt te laat.",
        "solutionSteps": [
          "Feit 1: Tim wordt om 8:15 wakker",
          "Feit 2: Hij heeft minstens 30 minuten nodig",
          "8:15 + 30 min = 8:45",
          "School begint om 8:30 → Tim komt te laat"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-007",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "text_highlight",
      "question": "Markeer het feit dat NIET bijdraagt aan de conclusie 'De wedstrijd wordt afgelast'.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Het heeft de hele nacht gestormd. Het voetbalveld staat onder water. De scheidsrechter draagt een rode jas. De trainer belt alle spelers om thuis te blijven.",
        "correctHighlights": [
          { "start": 69, "end": 106, "text": "De scheidsrechter draagt een rode jas" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Relevante vs irrelevante feiten", "content": "Niet alle zinnen in een tekst zijn relevant voor de conclusie. De kleur van de jas van de scheidsrechter heeft niets te maken met het afgelasten van de wedstrijd.", "icon": "lightbulb" } }
      ],
      "conceptId": "conclusie_irrelevant_feit",
      "variantIndex": 7,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.conclusie-detail-vs-conclusie", "label": "Markeert een relevant feit in plaats van het irrelevante detail" },
          { "id": "taa.conclusie-geldig-vs-ongeldig", "label": "Herkent niet welk feit niet bijdraagt aan de conclusie" }
        ]
      },
      "feedback": {
        "explanationText": "De kleur van de jas van de scheidsrechter is irrelevant voor de conclusie. De storm, het ondergelopen veld en het bellen van spelers dragen wél bij aan de conclusie dat de wedstrijd wordt afgelast.",
        "solutionSteps": [
          "Storm → relevant (oorzaak)",
          "Veld onder water → relevant (gevolg)",
          "Rode jas → NIET relevant (heeft niets met afgelasting te maken)",
          "Trainer belt spelers → relevant (bevestiging afgelasting)"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-CONCLUSIE-008",
      "familyId": "TAA-LEZEN-CONCLUSIE",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_conclusie",
      "questionType": "drag_drop_fill",
      "question": "Vul de juiste signaalwoorden in om de conclusie kloppend te maken.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "with_bank",
        "template": "Het regende de hele dag. {0} bleef de wedstrijd niet doorgaan, {1} het veld stond onder water.",
        "draggables": ["Daarom", "omdat", "hoewel", "terwijl"],
        "correctPlacements": { "0": 0, "1": 1 }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoorden voor oorzaak-gevolg",
            "content": "'Daarom' geeft het gevolg aan (regen → afgelasting). 'Omdat' geeft de reden aan (veld onder water → afgelasting). 'Hoewel' en 'terwijl' passen niet bij oorzaak-gevolg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "conclusie_signaalwoorden_bank",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.conclusie-voorspelling-vs-conclusie", "label": "Verwart tegenstelling-signaalwoord met oorzaak-gevolg-signaalwoord" },
          { "id": "taa.conclusie-mening-vs-conclusie", "label": "Kiest signaalwoord dat tijd of tegenstelling aangeeft i.p.v. gevolg/reden" }
        ]
      },
      "feedback": {
        "explanationText": "'Daarom' = gevolg (regen → wedstrijd ging niet door). 'Omdat' = reden (veld stond onder water). De twee afleiders 'hoewel' en 'terwijl' geven tegenstelling/tijd aan, niet oorzaak-gevolg.",
        "solutionSteps": [
          "Eerste gat: gevolg van de regen → 'Daarom'",
          "Tweede gat: reden waarom de wedstrijd niet doorging → 'omdat'",
          "Afleiders 'hoewel' en 'terwijl' passen niet"
        ]
      }
    }
  ]
}